import {
  EFieldsName,
  IDataPreference,
  IFiltrosPainelDeVendas
} from "@/features/financas/views/Indicadores/@types/type";
import { IShortcut } from "@/composables/shared/Shortcuts/Shortcut";
import { DITypes, EDateFormat } from "@/core/@types/types";
import { EshortCutShared } from "@/core/composables/F360DateShortcuts/types";
import PreferenciasTemplate from "../Preferencias/PreferenciasTemplate";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import { type IF360Date } from "@/core/plugins/date/F360Date";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";

const buildRangeObj = (filter: IShortcut) => {
  return {
    end: filter.finalDate,
    formatedDate: {
      end: filter.finalDate,
      start: filter.initialDate
    },
    start: filter.initialDate
  };
};

@injectable()
export default class PreferenciasPainelDeVendas extends PreferenciasTemplate<IFiltrosPainelDeVendas> {
  @inject(DITypes.DATE)
  private libDate!: IF360Date;

  constructor() {
    super(EWidgets.VendasPanel);
  }

  obterSourceData(fieldName: string): number {
    const sourceDataItem = this.filtrosDoCard.find(
      (sourceDataId: IDataPreference) => sourceDataId.fieldName == fieldName
    );
    const souceDataValue = sourceDataItem?.fieldData || 1;

    return souceDataValue as number;
  }

  handleCustomDateFiltros = (periodo: IDataPreference[]) => {
    const findRangeDataInicio = periodo.find(
      (filtro) => filtro.fieldName == EFieldsName.vendasShortcutPeriodoInicio
    )?.fieldData;
    const findRangeDataFim = periodo.find(
      (filtro) => filtro.fieldName == EFieldsName.vendasShortcutPeriodoFim
    )?.fieldData;
    const hasRange = findRangeDataInicio && findRangeDataFim;

    if (!hasRange) return;

    const initialFilter: IShortcut = {
      initialDate: this.libDate.format(
        findRangeDataInicio as string,
        EDateFormat.dateParmFormat
      ),
      finalDate: this.libDate.format(
        findRangeDataFim as string,
        EDateFormat.dateParmFormat
      )
    };

    const range = buildRangeObj(initialFilter);

    this.AtualizarFiltro(EshortCutShared.custom, range);

    return initialFilter;
  };
}
